<section class="pt-3">
  <screen-support></screen-support>  
</section>

<section class="sfe-safe  sfe-welcome">
  <div class="pt-5" >
    <h1 class="sfe-welcome-head">Models Assessments List
    </h1>
    <p>The model assessment is for all the businesses that are just getting started. Let's take a look at what we have listed below.  </p>
   
    <!--<div *ngIf="authService.isAdmin == false">
      <button class="sfe-capitalize sfe-button-round sfe-button-blue" mat-raised-button  routerLink="/entrep-dash"  >Dashboard</button>
    </div>
    <div *ngIf="authService.isAdmin == true">
      <button class="sfe-capitalize sfe-button-round sfe-button-blue" mat-raised-button  routerLink="/super-admin/admin-details"  >Dashboard</button>
    </div>-->
  </div>
</section>
<div class="pt-5"></div>
<mat-card class=" mx-auto">

  <!-- No data shows when their is no data available -->
  <div class="no-data text-center" *ngIf="!data?.length">

    <p class="nodata-msg">No Assessments added yet! </p>
      <p> Share your Admin Code with your entrepreneurs and ask them to take an assessment!</p>
    <br/>
    <p>Having Problems? <a routerLink="/troubleshoot">Troubleshoot</a></p>
  </div>

  <!-- Showing data -->
  <div class="table-responsive" *ngIf="data?.length">
    <table  class="table  table-responsive-sm table-responsive-md table-responsive-lg">
      <thead>
        <tr>
          <th scope="col">Business name</th>
          <th scope="col">Owner Name</th>
          <th scope="col">Results</th>
        </tr>
      </thead>
      <tbody>
        <!-- *ngFor loop iterates over Student array and fetch the student's data -->
        <!-- paginate pipe will add pagination in student's list, it won't show if items are less then 7 -->

        <tr *ngFor="let assessment of data |  paginate: { itemsPerPage: 7, currentPage: p }; let i = index;">
          <td>{{assessment.busiName}}</td>
          <td>{{assessment.busiFirstName}} {{assessment.busiLastName}}</td>
          <td>
            <div class="btn-group pr-3">
              <button class="sfe-capitalize sfe-button-round sfe-button-blue" mat-raised-button id="AssessmentResults" routerLink="/model-results/{{assessment.key}}">Results</button>
            </div>
          </td>
        </tr>
        
      </tbody>
    </table>
  </div>
  <!-- Pagination -->
  <pagination-controls (pageChange)="p = $event" autoHide="true" responsive="true"></pagination-controls>
</mat-card>
<!--<h2>Answer Here: {{numberInt}}</h2>-->
<!--K-Andre Testing itemKeys-->
<!--<div class="row">
    <div *ngFor =" let itemKey of itemKeys" class="col">
      <a  routerLink="/views/{{itemKey}}" >
    {{itemKey}}
  </a>
    </div>
  </div>-->